import { DeleteModelMessage, CollisionFacet, PrimitiveMeshFacet, PrimitiveShape, LocalTransformFacet, UpdateFacetOnModelMessage, convertToNumber3, ChangeModelShapeAction, ChangeModelColorAction, ChangeModelMaterialAction, DeleteModelAction, AutoScaleChildrenFacet } from "flavr-common";
import { InteractionHandler } from "../Interactions";
import { Vector3 } from "flavr-math";
import { modelPool } from "@modules/model";
const tmpScale = new Vector3();
const ROOM_MARGINS_FOR_SHAPES = {
    box: { margin: 0.01 },
    sphere: { margin: 0.49 * (1 - 1 / Math.sqrt(3)) },
    cylinder: {
        margin: 0.49 * (1 - 1 / Math.sqrt(2)),
        bottom_margin: 0.01,
        top_margin: 0.01
    },
    cone: {
        margin: 0.48 * (1 - 1 / Math.sqrt(2)),
        bottom_margin: 0.01,
        top_margin: 0.5
    },
    pyramid: { margin: 0.05, bottom_margin: 0.01, top_margin: 0.5 },
    prism: {
        margin: 0.01,
        left_margin: 0.05,
        right_margin: 0.05,
        top_margin: 0.5
    }
};
export class ModifierModelInteractionHandler extends InteractionHandler {
    constructor() {
        super("ModifierModelInteractionHandler", [], [
            ChangeModelShapeAction.typestatic,
            ChangeModelColorAction.typestatic,
            ChangeModelMaterialAction.typestatic,
            DeleteModelAction.typestatic
        ], []);
    }
    performAction(params, context) {
        if (context.targetUid === undefined)
            return;
        const uid = context.targetUid;
        if (ChangeModelShapeAction.is(params)) {
            this.changeModelShape(uid, params.shape);
        }
        else if (ChangeModelColorAction.is(params)) {
            this.changeModelColor(uid, params.color);
        }
        else if (ChangeModelMaterialAction.is(params)) {
            this.changeModelMaterial(uid, params.material);
        }
        else if (DeleteModelAction.is(params)) {
            this.connection.send(new DeleteModelMessage(uid));
        }
    }
    changeModelColor(uid, color) {
        const primitiveMesh = this.getFacetForModel(uid, PrimitiveMeshFacet);
        if (primitiveMesh === undefined)
            return;
        this.connection.send(new UpdateFacetOnModelMessage(uid, new PrimitiveMeshFacet(primitiveMesh.shape, color, primitiveMesh.material)));
    }
    changeModelMaterial(uid, material) {
        const primitiveMesh = this.getFacetForModel(uid, PrimitiveMeshFacet);
        if (primitiveMesh === undefined)
            return;
        this.connection.send(new UpdateFacetOnModelMessage(uid, new PrimitiveMeshFacet(primitiveMesh.shape, primitiveMesh.color, material)));
    }
    changeModelShape(uid, shape) {
        var _a;
        const collisionFacet = this.getFacetForModel(uid, CollisionFacet);
        if (collisionFacet === undefined)
            return;
        const primitiveMesh = this.getFacetForModel(uid, PrimitiveMeshFacet);
        if (primitiveMesh === undefined)
            return;
        const model = modelPool.getModel(uid);
        if (model === undefined)
            return;
        if (model.isRoom()) {
            const margin = (_a = ROOM_MARGINS_FOR_SHAPES[shape]) !== null && _a !== void 0 ? _a : { margin: 0.01 };
            this.connection.send(new UpdateFacetOnModelMessage(uid, new AutoScaleChildrenFacet(margin, [0, -0.5, 0])));
        }
        if (shape === PrimitiveShape.Sphere || shape === PrimitiveShape.Cylinder || shape === PrimitiveShape.Cone) {
            const transform = this.getFacetForModel(uid, LocalTransformFacet);
            const messages = [];
            if (transform !== undefined) {
                const newScale = tmpScale.fromArray(transform.scale);
                if (shape === PrimitiveShape.Sphere) {
                    newScale.setScalar(Math.max(newScale.x, newScale.y, newScale.z));
                }
                else if (shape === PrimitiveShape.Cylinder || shape === PrimitiveShape.Cone) {
                    newScale.z = newScale.x = Math.max(newScale.x, newScale.z);
                }
                messages.push(new UpdateFacetOnModelMessage(uid, new LocalTransformFacet(transform.position, transform.orientation, convertToNumber3(newScale))));
            }
            messages.push(new UpdateFacetOnModelMessage(uid, new PrimitiveMeshFacet(shape, primitiveMesh.color, primitiveMesh.material)));
            messages.push(new UpdateFacetOnModelMessage(uid, new CollisionFacet(shape, collisionFacet.isSelectable)));
            this.connection.sendMultiple(messages);
        }
        else {
            this.connection.sendMultiple([
                new UpdateFacetOnModelMessage(uid, new PrimitiveMeshFacet(shape, primitiveMesh.color, primitiveMesh.material)),
                new UpdateFacetOnModelMessage(uid, new CollisionFacet(shape, collisionFacet.isSelectable))
            ]);
        }
    }
    getFacetForModel(uid, facetType) {
        var _a;
        return (_a = modelPool === null || modelPool === void 0 ? void 0 : modelPool.getModel(uid)) === null || _a === void 0 ? void 0 : _a.getFacet(facetType);
    }
}
